import { useEffect, useState } from 'react';
import { useConnectionObjectApi } from '../Services/ConnectionObjectApiProvider';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Table from '../Components/Tables';
import { formatDateUTC } from '../utils/formatDate';

function ConnectionObjectsList() {
  const { getObjectsByConnectionId } = useConnectionObjectApi();
  const { organizationId, connectionId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [objects, setObjects] = useState([]);
  const [totalCountObjects, setTotalCountObjects] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const columns = [
    { name: 'ID', selector: (row) => row.id },
    { name: 'Name', selector: (row) => row.name },
    { name: 'Type', selector: (row) => row.type },
    { name: 'Status', selector: (row) => (row.is_active ? 'Active' : 'Inactive') },
    { name: 'Created', selector: (row) => formatDateUTC(row.created_at) },
  ];

  const fetchObjects = async (connectionId, skip, limit) => {
    if (limit !== itemsPerPage) {
      setItemsPerPage(limit);
    }
    try {
      setLoading(true);
      const response = await getObjectsByConnectionId(connectionId, skip, limit);
      setObjects(response.items);
      setTotalCountObjects(response.totalCount);
    } catch (err) {
      console.error('Error fetching Connection Objects:', err);
      setError('Failed to load Connection Objects');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchObjects(connectionId, 0, itemsPerPage);
  }, [connectionId, itemsPerPage]);

  const handleRowClick = (row) => {
    console.log('location.pathname', location.pathname);
    navigate(`/organizations/${organizationId}/connection-objects/${row.id}`, {
      state: {
        from: location.pathname,
        activeTab: 'view-objects',
      },
    });
  };

  return (
    <>
      {error ? (
        <div>Error: {error}</div>
      ) : (
        <Table
          title="Connection Objects"
          columns={columns}
          data={objects}
          onRowClicked={handleRowClick}
          selectableRowsHighlight
          progressPending={loading}
          paginationPerPage={itemsPerPage}
          paginationTotalRows={totalCountObjects}
          sortIcon={<i className="fa-solid fa-chevron-down"></i>}
          onChangePage={fetchObjects}
        />
      )}
    </>
  );
}

export default ConnectionObjectsList;
